import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import Button from "react-bootstrap/Button";

import { BsGithub } from "react-icons/bs";
import { SiRoblox } from 'react-icons/si'
import { FaDiscord, FaGithub } from "react-icons/fa";

function Projects() {
  return (
    <Container fluid className="project-section">

      <Container>
        <h1 className="project-heading">
          Hi! Welcome, <strong className="purple">guest! </strong>
        </h1>
        <p style={{ color: "white" }}>
        Website is under development and will be available soon.
        </p>

        <Button style={{marginBottom: "10px"}} variant="dark" href={"https://github.com/iamreiyn"} target="_blank">
            <BsGithub /> My GitHub profile
          </Button><br></br>
          <Button style={{marginBottom: "10px"}} variant="dark" href="https://devforum.roblox.com/u/iamrenisal/summary" target="_blank">
            <SiRoblox /> My Roblox DevForum profile
          </Button><br></br>
          <Button style={{marginBottom: "10px"}} variant="success" href="https://discord.gg/3Zn6xtKSF8" target="_blank">
            <FaDiscord /> My Roblox development server
          </Button>
       
        {/* <Row style={{ justifyContent: "center", paddingBottom: "10px" }}> */}
{/* 
        <Col md={4} className="project-card">
            <ProjectCard
              imgPath="https://youtu.be/vQpJdsgfgWk"
              isBlog={false}
               videoPath="https://youtu.be/vQpJdsgfgWk"
              title="Protocol Broken"
              description="Cutscene for when player breaks a protocol within my small Horror game."
             // ghLink="https://github.com/soumyajit4419/AI_For_Social_Good"
               demoLink="https://www.youtube.com/watch?v=vQpJdsgfgWk"
            />
          </Col>

        <Col md={4} className="project-card">
            <ProjectCard
              imgPath="https://media.licdn.com/dms/image/v2/D4E12AQEfFaEqi62KjA/article-inline_image-shrink_400_744/article-inline_image-shrink_400_744/0/1706635650251?e=1746057600&v=beta&t=Ju0SxUzp1FHpQCyK0mYoyDB9kJ5_epVCgz93HPRwOR8"
              isBlog={false}
               videoPath="https://youtu.be/TCPZLJCLPcI"
              title="Advanced Citizen AI #1"
              description="Responds to various events throughout the  (such as violence), customizable. Has custom chat UI."
             // ghLink="https://github.com/soumyajit4419/AI_For_Social_Good"
               demoLink="https://drive.google.com/file/d/1SvianfHHX_OdJlyRVmv0aUoflzqlm0pt/view"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="https://camo.githubusercontent.com/b2a89abd9a8103f10df9ac58ddccfeeb5736359c09b585eae55144e632b927cf/68747470733a2f2f692e696d6775722e636f6d2f5a4e68627241642e706e67"
              isBlog={false}
              title="ᵂᴱᴮ ᴰᴱⱽ Lua Pattern Tester"
              description="An open-Source and live web-based tool for testing, matching and debugging Lua patterns against your input. Primarily made for personal use, but apparently many people found it useful on GitHub."
              ghLink="https://github.com/iamreiyn/lua-pattern-tester"
              demoLink="/lua-pattern-tester/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="https://i.postimg.cc/rpSq6n7J/Screenshot-2025-01-15-153403.png"
              isBlog={false}
              title="ᵂᴱᴮ ᴰᴱⱽ Terminal Portfolio"
              description="An interactive, retro terminal-style portfolio template built with react.js."
              ghLink="https://github.com/iamreiyn/terminal-portfolio"
              demoLink="/terminal-portfolio"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="https://i.postimg.cc/Dy2JcWSv/Screenshot-2025-03-04-191208.png"
              isBlog={false}
              title="ᵂᴱᴮ ᴰᴱⱽ HTML/CSS Responsive"
              description="Open-Source Responsive 2023 Apple's website clone built with HTML and CSS."
              ghLink="https://github.com/iamreiyn/apple-website-clone"
              demoLink="/apple-website-clone"
            />
          </Col>

         
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="https://i.postimg.cc/pTsbb1J1/d5555542-original.jpg"
              isBlog={false}
              title="³ᴰ ᴹᴼᴰᴱᴸᴵᴺᴳ Watch Prototype"
              description="A simple 3D watch prototype created in Blender. And my first ever complete 3D model."
              ghLink="#"
              demoLink="#"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="https://i.postimg.cc/BbtWqchZ/fd13173e-original.jpg"
              isBlog={false}
              title="³ᴰ ᴹᴼᴰᴱᴸᴵᴺᴳ Cube Render"
              description="My terrible attempt at rendering a 3D cube model that I made within Blender."
              //ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
               demoLink="reiynstudio.ink/password-generator/" 
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="https://i.postimg.cc/Xv00w5vx/c79286b5-original.jpg"
              isBlog={false}
              title="ᵂᴱᴮ ᴰᴱⱽ Password Generator"
              description="An open-source sophisticated password generating application built with react.js, created for personal use."
              //ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
               demoLink="/password-generator/" 
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="https://i.postimg.cc/Kc9Fd49v/a548754d-original.jpg"
              isBlog={false}
              title="ᵂᴱᴮ ᴰᴱⱽ Regular Expressions Tester"
              description="An open-source sophisticated password generating application built with react.js, created for personal use.A live web-based tool for testing, matching and debugging Regular Expressions against your input."
              //ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
               demoLink="/regex-validator/" 
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="https://i.postimg.cc/6pZX2cBy/81f4c233-original.jpg"
              isBlog={false}
              title="ᵂᴱᴮ ᴰᴱⱽ Crypto-data Retriever"
              description="An open-source simple real-time crypto-currency data retrieving app built with react.js, primarily created for practicing Web APIs."
              //ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
               demoLink="/cryptodata-retriever/" 
            />
          </Col>


        
        </Row> */}
      </Container>
      
    </Container>
  );
}

export default Projects;
